import React from "react";
import { useNavigate } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import screen from "./sceen.jpg";
import screen1 from "./sceen1.png";

const DallasHubPage = () => {
  const navigate = useNavigate();
  const location = [33.1507, -96.8253]; // Coordinates for 6000 Eldorado Parkway, Frisco, TX

  // Dark theme styles
  const styles = {
    container: {
      backgroundColor: "#121212",
      color: "#e0e0e0",
      padding: "20px",
      maxWidth: "1200px",
      margin: "auto",
      fontFamily: "'Roboto', sans-serif",
      minHeight: "100vh",
    },
    button: (bgColor) => ({
      padding: "10px 20px",
      backgroundColor: bgColor,
      color: "#fff",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      marginBottom: "20px",
      fontSize: "1em",
    }),
    header: {
      textAlign: "center",
      marginBottom: "30px",
      fontSize: "2em",
    },
    imageRow: {
      display: "flex",
      gap: "20px",
      justifyContent: "center",
      marginBottom: "20px",
      flexWrap: "wrap",
    },
    smallImage: {
      width: "45%",
      maxWidth: "400px",
      borderRadius: "10px",
    },
    paragraph: {
      fontSize: "1.2em",
      lineHeight: "1.6",
    },
    strong: {
      fontWeight: "bold",
    },
    contact: {
      fontSize: "1.2em",
      fontWeight: "bold",
    },
    actionContainer: {
      display: "flex",
      gap: "20px",
      marginBottom: "30px",
      justifyContent: "center",
      flexWrap: "wrap",
    },
    mapContainer: {
      height: "400px",
      borderRadius: "10px",
      marginBottom: "30px",
    },
    sectionHeader: {
      textAlign: "center",
      marginBottom: "20px",
      fontSize: "1.5em",
    },
    centeredText: {
      textAlign: "center",
      fontSize: "1.2em",
    },
  };

  return (
    <div style={styles.container}>
      {/* Back Button */}
      <button style={styles.button("#007bff")} onClick={() => navigate(-1)}>
        Back
      </button>

      <h1 style={styles.header}>Dallas Hub</h1>

      {/* Row of Two Images */}
      <div style={styles.imageRow}>
        <img src={screen} alt="Dallas Hub" style={styles.smallImage} />
        <img src={screen1} alt="Vehicles" style={styles.smallImage} />
      </div>

      {/* Hub Details */}
      <div style={{ marginBottom: "30px" }}>
        <p style={styles.paragraph}>
          Welcome to the Dallas Hub located at{" "}
          <strong style={styles.strong}>
            6000 Eldorado Parkway, Frisco, TX
          </strong>
          . We’re here to assist you with your vehicle needs. Feel free to
          rent a vehicle, make an appointment, or contact us for further
          assistance.
        </p>
        <p style={styles.contact}>
          Phone:{" "}
          <a href="tel:4698349406" style={{ color: "#80bdff" }}>
            469-834-9406
          </a>
        </p>
      </div>

      {/* Action Buttons */}
      <div style={styles.actionContainer}>
        <button
          style={styles.button("#007bff")}
          onClick={() => navigate("/feedback")}
        >
          Make an Appointment
        </button>
        <button
          style={styles.button("#28a745")}
          onClick={() => navigate("/rent")}
        >
          Rent from this Location
        </button>
      </div>

      {/* Map Section */}
      <div style={{ marginBottom: "30px" }}>
        <h3 style={styles.sectionHeader}>Find Us Here</h3>
        <MapContainer center={location} zoom={15} style={styles.mapContainer}>
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <Marker position={location}>
            <Popup>
              Dallas Hub <br />
              6000 Eldorado Parkway, Frisco, TX
            </Popup>
          </Marker>
        </MapContainer>
      </div>

      {/* Available Vehicles Section */}
      <div>
        <h3 style={styles.sectionHeader}>Available Vehicles</h3>
        <p style={styles.centeredText}>
          Explore the vehicles available at our Dallas Hub.
        </p>
        {/* Additional content for vehicle listings can go here */}
      </div>
    </div>
  );
};

export default DallasHubPage;
